import React from "react";
import {useDepartment} from "../../api/platform/useDepartments";

type Props = {
    departmentID: string;
}

export function DepartmentName({departmentID}: Props) {
    const {data: department, isLoading} = useDepartment(departmentID);
    if (isLoading) return <span className="inline-block h-3 w-24 rounded-full bg-light-light-grey animate-pulse" />;
    if (!department) return <span className="text-light-grey">—</span>;
    return <>{department.name}</>;
}
